import { IApplicationState } from '../../types/redux';
import { ETab } from '../../types/tab';

export const getIsReviewTab = (state: IApplicationState): boolean => {
  return state.tabs === ETab.Reviews;
};
